import React, { useState, useEffect } from 'react';
import { globeService } from '../../services/globeService';
import './VesselComplianceBadge.css';

/**
 * Compact behavioural-risk chips for a hull (dark activity, ship-to-ship,
 * flag risk, sanctioned-zone visit). Self-fetching and config-gated: renders
 * NOTHING unless vessel screening is enabled AND at least one risk is active,
 * so a clean vessel adds no visual noise. No vendor name ever appears.
 */
const RISK_DEFS = [
  { key: 'dark_activity', label: 'Dark', title: 'AIS gap / dark activity detected' },
  { key: 'sts', label: 'STS', title: 'Ship-to-ship transfer detected' },
  { key: 'flag_risk', label: 'Flag risk', title: 'Flag / registry risk' },
  { key: 'zone_visits', label: 'Zone', title: 'Recent call in a sanctioned zone' },
  { key: 'detention', label: 'Detention', title: 'Port State Control detention on record' },
];

function isActive(value) {
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') return Object.keys(value).length > 0;
  return Boolean(value);
}

function VesselRiskChips({ imo }) {
  const [risk, setRisk] = useState(null);

  useEffect(() => {
    let active = true;
    if (!imo) {
      setRisk(null);
      return undefined;
    }
    globeService
      .getVesselRisk(imo)
      .then((res) => {
        if (active) setRisk(res && res.configured ? res.data || {} : null);
      })
      .catch(() => {
        if (active) setRisk(null);
      });
    return () => {
      active = false;
    };
  }, [imo]);

  if (!risk) return null;

  const chips = RISK_DEFS.filter((d) => isActive(risk[d.key]));
  if (chips.length === 0) return null;

  return (
    <>
      {chips.map((c) => (
        <span key={c.key} className="vessel-risk-chip" title={c.title}>
          {c.label}
        </span>
      ))}
    </>
  );
}

export default VesselRiskChips;
